import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Version from '../../version'
import { useAuth } from '../auth/useAuth'
import { useEffect, useState } from 'react'

export default function Sidebar() {
	const { t } = useTranslation()
	const { clientauth, logout } = useAuth()
	const role = String(clientauth?.rol || '').toLowerCase()

	const { pathname } = useLocation()
	const [rolTranslated, setRolTranslated] = useState(role)

	useEffect(() => {
		setRolTranslated(role)
	}, [role])

	const isActive = (path) => {
		const current = pathname.replace(/^\/+/, '')
		return current === path || current.startsWith(path + '/')
	}

	return (
		<div className="sidebar d-none d-lg-flex" id="sidebar">
			<div className="sidebar-logo">
				<img src="/images/logo-inicio.png" alt="logotipo" />
			</div>

			<div className="sidebar-nav">
				<Link
					className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.dashboard')}`) ? ' active' : ''}`}
					to={`/${t('url.'+rolTranslated)}/${t('url.dashboard')}`}
				>
					<i className="fas fa-chart-pie"></i>
					<span>{t('menu.index')}</span>
				</Link>

				{rolTranslated === 'admin' && (
					<>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.users')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.users')}`}
						>
							<i className="fas fa-users"></i>
							<span>{t('menu.users')}</span>
						</Link>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.products')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.products')}`}
						>
							<i className="fas fa-barcode"></i>
							<span>{t('menu.products')}</span>
						</Link>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.departments')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.departments')}`}
						>
							<i className="fas fa-building"></i>
							<span>{t('menu.departments')}</span>
						</Link>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.delegations')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.delegations')}`}
						>
							<i className="fas fa-warehouse"></i>
							<span>{t('menu.delegations')}</span>
						</Link>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.productStates')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.productStates')}`}
						>
							<i className="fas fa-tags"></i>
							<span>{t('menu.productStates')}</span>
						</Link>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.productTemplates')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.productTemplates')}`}
						>
							<i className="fas fa-layer-group"></i>
							<span>{t('menu.productTemplates')}</span>
						</Link>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.chatbot')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.chatbot')}`}
						>
							<i className="fas fa-comment-dots"></i>
							<span>{t('menu.chatbot')}</span>
						</Link>
					</>
				)}

				{rolTranslated === 'department' && (
					<>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.dashboard')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.dashboard')}`}
						>
							<i className="fas fa-chart-pie"></i>
							<span>{t('menu.index')}</span>
						</Link>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.products')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.products')}`}
						>
							<i className="fas fa-barcode"></i>
							<span>{t('menu.products')}</span>
						</Link>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.chatbot')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.chatbot')}`}
						>
							<i className="fas fa-comment-dots"></i>
							<span>{t('menu.chatbot')}</span>
						</Link>
					</>
				)}

				{rolTranslated === 'commercial' && (
					<>
						<Link
							className={`nav-link-pill${isActive(`${t('url.'+rolTranslated)}/${t('url.chatbot')}`) ? ' active' : ''}`}
							to={`/${t('url.'+rolTranslated)}/${t('url.chatbot')}`}
						>
							<i className="fas fa-comment-dots"></i>
							<span>{t('menu.chatbot')}</span>
						</Link>
					</>
				)}
			</div>

			<div className="sidebar-footer">
				<div className="sidebar-user">
					<div className="avatar-initials">
						{(clientauth?.name || clientauth?.username || 'U').charAt(0).toUpperCase()}
					</div>
					<div className="sidebar-user-info">
						<div className="sidebar-user-name">{clientauth?.name || clientauth?.username}</div>
						<div className="sidebar-user-email">{clientauth?.email}</div>
					</div>
				</div>
				<Link className="nav-link-pill sidebar-logout" to={"/"} onClick={logout}>
					<span>{t('global.logout')}</span>
				</Link>
				<div className="sidebar-version">
					<Version />
				</div>
			</div>
		</div>
	)
}
